// material-ui
import { DataGrid } from '../../../components/grid/DataGrid';

// project import
import MainLayout from '../../../layout/MainLayout';
import { useSelector, useDispatch } from 'react-redux';
import React, { useState } from 'react';
import MainCard from '../../../components/MainCard';
import {
  DeleteOutlined,
  EditOutlined,
  OrderedListOutlined,
  ScheduleOutlined
} from '@ant-design/icons';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton
} from '@mui/x-data-grid-pro';
import AnimateButton from 'components/@extended/AnimateButton';

import { Button, Box } from '@mui/material';

import {
  actions as routeActions,
  types as routes
} from 'reducers/rotas.actions';

import * as actions from 'reducers/produtosEtapas.reducer';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import useTheme from '@mui/system/useTheme';
import { toast } from 'react-toastify';
import { funcaoFiltro } from 'utils/funcaoFiltro';
import { opcoesFiltro } from 'utils/opcoesFiltro';
import { Grid, Typography } from '../../../../node_modules/@mui/material/index';
import Loader from 'components/Loader';

const EtapasPage = () => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const etapas = useSelector((state) => state.produtosEtapas.etapas.data);
  const produto = useSelector((state) => state.produtos.produto.data);
  const loadingProduto = useSelector((state) => state.produtos.produto.loading);
  const loading = useSelector((state) => state.produtosEtapas.etapas.loading);

  const disabled = produto?.tipoSituacao !== 'A';

  const idOperacao = useSelector((state) => state.produtosEtapas.idOperacao);

  const rows = etapas;

  const columns = [
    {
      field: 'nomeEtapa',
      headerName: 'Nome',
      flex: 1
    },
    {
      field: 'ordemEtapa',
      headerName: 'Ordem',
      flex: 1
    },
    {
      field: 'tipoSituacao',
      headerName: 'Situação',
      flex: 1,
      valueFormatter: (value) => {
        return value === 'A' ? 'Ativo' : value === 'I' ? 'Inativo' : '';
      },
      filterOperators: [
        {
          label: 'igual à',
          value: 'is',
          getApplyFilterFn: (filterItem) => funcaoFiltro(filterItem),
          InputComponent: (props) =>
            opcoesFiltro(props, [
              { codigo: 'A', nome: 'Ativo' },
              { codigo: 'I', nome: 'Inativo' }
            ])
        }
      ]
    }
  ];

  const [open, setOpen] = useState(false);

  const handleClickOpen = (row) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNewProduto = () => {
    dispatch(
      routeActions.redirectTo(routes.PRODUTO_ETAPA, {
        idEtapa: 'novo',
        idOperacao
      })
    );
  };

  const handleGoBack = () => {
    dispatch(
      routeActions.redirectTo(routes.PRODUTOS, {
        idOperacao
      })
    );
  };

  const CustomToolbar = ({ apiRef }) => {
    const selectedRows = apiRef.current.getSelectedRows();
    const selectedRowData = Array.from(selectedRows.values());

    const handleDeleteClick = () => {
      dispatch(actions.excluirEtapaRequest({ value: selectedRowData[0] }));
      setOpen(false);
    };

    const handleEdit = () => {
      if (selectedRows.size === 0) {
        toast.error('Selecione pelo menos uma linha.');
      } else {
        dispatch(
          routeActions.redirectTo(routes.PRODUTO_ETAPA, {
            idEtapa: selectedRowData[0].idEtapa,
            idOperacao
          })
        );
      }
    };

    const handleClickEtapas = () => {
      dispatch(
        routeActions.redirectTo(routes.PRODUTO_ATIVIDADES, {
          idOperacao: idOperacao,
          idEtapa: selectedRowData[0].idEtapa
        })
      );
    };

    return (
      <>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>Confirmação para Exclusão de Etapa</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Tem certeza de que deseja excluir a Etapa{' '}
              {selectedRowData[0]?.nomeEtapa}? Ao excluir uma etapa, não será
              mais possível recuperar suas informações.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary">
              Cancelar
            </Button>
            <Button onClick={handleDeleteClick} color="error">
              Excluir
            </Button>
          </DialogActions>
        </Dialog>

        <GridToolbarContainer>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport
            csvOptions={{ includeHeaders: true, allColumns: true }}
          />
          <Button
            disabled={disabled}
            variant="text"
            color="primary"
            onClick={handleNewProduto}
            startIcon={<OrderedListOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Incluir Etapa
          </Button>
          <Button
            variant="text"
            color="primary"
            disabled={selectedRows.size !== 1}
            onClick={handleEdit}
            startIcon={<EditOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Editar
          </Button>
          <Button
            variant="text"
            color="primary"
            disabled={
              selectedRows.size !== 1 ||
              selectedRowData[0]?.tipoSituacao !== 'A'
            }
            onClick={handleClickOpen}
            startIcon={<DeleteOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px',
              color: `${
                selectedRows.size !== 1 ||
                selectedRowData[0]?.tipoSituacao !== 'A'
                  ? theme.palette.grey.lighter
                  : theme.palette.error.main
              } !important`
            }}
          >
            Excluir
          </Button>
          <Button
            variant="text"
            color="primary"
            disabled={selectedRows.size !== 1}
            onClick={handleClickEtapas}
            startIcon={<ScheduleOutlined />}
            sx={{
              maxHeight: 30.75,
              paddingTop: '4px',
              paddingBottom: '4px',
              paddingLeft: '5px',
              paddingRight: '5px'
            }}
          >
            Atividades
          </Button>
        </GridToolbarContainer>
      </>
    );
  };

  if (loadingProduto) {
    return (
      <MainLayout>
        <Loader />
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <MainCard
        title={
          <Box>
            <Typography variant="h2">{produto?.nomeOperacao}</Typography>
            <Typography variant="subtitle1" color="textSecondary">
              Etapas
            </Typography>
          </Box>
        }
      >
        <Box sx={{ marginTop: '5px' }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSizeOptions={[10]}
            getRowId={(row) => row.idEtapa}
            toolbar={CustomToolbar}
            loading={loading}
            pageSize={10}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10
                }
              },
              density: 'standard'
            }}
            noLineText="Nenhuma etapa encontrada"
          />
        </Box>

        <Grid
          container
          style={{ marginTop: 20, justifyContent: 'end', marginBottom: 20 }}
          spacing={2}
        >
          <Grid item xs={12} md={4}>
            <AnimateButton>
              <Button
                disableElevation
                fullWidth
                size="large"
                type="button"
                variant="outlined"
                color="secondary"
                onClick={handleGoBack}
              >
                VOLTAR
              </Button>
            </AnimateButton>
          </Grid>
        </Grid>
      </MainCard>
    </MainLayout>
  );
};

export default EtapasPage;
